import { AnchorButton } from "@blueprintjs/core";
import * as React from "react";
import { WithTranslation, withTranslation } from "react-i18next";

interface IProps {
  trackingIds: string;
}

class TrackNowLink extends React.Component<IProps & WithTranslation> {
  public render() {
    const { t, trackingIds } = this.props;
    const href = `https://t.17track.net/en#nums=${trackingIds}`;

    return (
      <AnchorButton
        large={true}
        intent="primary"
        href={href}
        target={"_blank"}
        rel={"noopener"}
        style={{ marginBottom: "24px" }}
      >
        {t("trackNowBtn")}
      </AnchorButton>
    );
  }
}

export default withTranslation("trackTrace")(TrackNowLink);



// WEBPACK FOOTER //
// ./src/components/TrackTrace/TrackNowLink.tsx